<template>
  <div>
    <select v-model="selectedSetName" class="custom-select form-text-dark col-8 mt-2">
      <option v-for="set in selectionSets" :key="set.name" :value="set.name">{{ set.name }}</option>
      <option disabled value="">Select a selection set</option>
    </select>
    <!--<div v-else>
      No selection sets found
    </div>-->
    <div class="w-100"/>
    <div v-if="selectedSetName && unmatchedItems !== 0" class="matched-msg p-3 mt-2 mb-2 border-radius">
      {{ $t('filter.unmatched') }}
      <div class="w-100"/>
      <div
          v-if="unmatchedItems > 0 && selectedSetName && selectedSet.nodes.length"
          class="settings-button d-inline-block mt-2"
          @click="addMatchedInstances">
        {{ $t('filter.add') }} {{ selectedSet ? selectedSet.nodes.length : 0 }} {{ $t('parts') }}
      </div>
    </div>
    <div class="matched-parts mt-2">
      {{ $t('filter.allItemsInSetAreIn') }}:
      <div
          v-for="set in matchedSets"
          :key="set.name">
        <div class="lighter mb-1">
          {{ set.name }} ({{ set.nodes.length }} {{ $t('parts') }})
        </div>
      </div>
      <div v-if="matchedSets.length === 0" class="lighter">
        -
      </div>
    </div>
    <div
        v-if="filter.length > 0"
        class="d-inline-block settings-button mt-2 switched-colors"
        @click="resetInstances"><icon type="trash" /> {{ $t('filter.removeAll') }}
    </div>
  </div>
</template>

<script>
import {vSTAGEFileNames} from "@/enum";
import {mapState} from "vuex";
import _ from "lodash";
import Icon from "@/components/Icon.vue";
export default {
  name: "SelectionSetSelector",
  components: {Icon},
  props: {
    assemblyId: {
      type: String,
      required: true
    },
    filterId: {
      type: String,
      default: ''
    },
    type: {type: String, default: 'filter'}, // filter or merge
  },
  data() {
    return {
      availableProjects: [],
      selectedProject: null,
      instances: [],
      selectionSets: [],
      selectedSetName: null,
      loading: false,
      error: null,
      filter: [],
      forceReRenderKey: 0,
    };
  },
  computed: {
    ...mapState({exportProfiles: state => state.exportprofile.exportProfiles,}),
    selectedSet() {
      return this.selectionSets.find(set => set.name === this.selectedSetName);
    },
    matchedItems() {
      if (!this.selectedSet || !this.selectedSet.nodes) return 0;
      return this.selectionSetInFilter(this.selectedSet.name).matched;
    },
    unmatchedItems() {
      if (!this.selectedSet || !this.selectedSet.nodes) return 0;
      return this.selectionSetInFilter(this.selectedSet.name).unmatched;
    },
    matchedSets() {
      return this.selectionSets.filter(set => this.selectionSetInFilter(set.name).unmatched === 0);
    }
  },
  watch: {
    exportProfiles() {
      //this.setUpExistingProfile();
    },
  },
  beforeMount() {
    this.loadSelectionSets();
    this.setUpExistingProfile();
  },
  methods: {
    async loadSelectionSets() {
      await this.$store.dispatch('clientDownloadAsset', {
        id: this.assemblyId,
        key: vSTAGEFileNames.vStageSelectionSets
      }).then(res => {
        console.log('loadSelectionSets', res);
        if (res && res.body) {
          const yaml = res.body;
          this.setSelectionSets(yaml);
        }
        this.forceReRenderKey++;
      }).catch(error => {
        this.error = error.message || 'Failed to load selection sets';
      })
    },
    selectionSetInFilter(selectionSetName) {
      const selectionSet = this.selectionSets.filter(set => set.name === selectionSetName);
      if (!selectionSet || !selectionSet.length) return false;
      const partInstanceIds = selectionSet[0].nodes;
      let matched = 0;
      let unmatched = 0;
      for (let i = 0; i < partInstanceIds.length; i++) {
        if (this.filter.includes(partInstanceIds[i])) {
          matched++;
        } else {
          unmatched++;
        }
      }
      return {
        matched,
        unmatched
      };
    },
    setUpExistingProfile() {
      const val = this.exportProfiles;
      if (val[this.filterId]) {
        const res = this.type === 'filter' ? this.$store.getters.getExportFilterIdArrayById(this.filterId) : this.$store.getters.getExportMergeIdArrayById(this.filterId);
        console.log('setUpExistingProfile', this.filterId, res, res.length);
        if (res && res.length) {
          this.filter = _.cloneDeep(res);
        } else {
          this.filter = [];
        }
      }
      this.forceReRenderKey++;
    },
    async resetInstances() {
      this.filter = [];
      await this.$store.dispatch(this.type === 'filter' ? 'overWriteFilterIdArray' : 'overWriteMergeIdArray', {
        id: this.filterId,
        value: []
      });
      this.forceReRenderKey++;
    },
    async addMatchedInstances() {
      // add all instances from the selected set that are not already in the filter
      if (!this.selectedSet || !this.selectedSet.nodes) {
        console.log('No selection set or assemblies found');
        return;
      }
      const partInstanceIds = this.selectedSet.nodes;

      for (let i = 0; i < partInstanceIds.length; i++) {
        if (this.filter.includes(partInstanceIds[i])) {
          continue;
        }
        this.filter.push(partInstanceIds[i]);
      }
      await this.$store.dispatch(this.type === 'filter' ? 'overWriteFilterIdArray' : 'overWriteMergeIdArray', {
        id: this.filterId,
        value: this.filter
      });
      this.forceReRenderKey++;
    },
    setSelectionSets(array) {
      if (!array || !Array.isArray(array)) {
        this.error = 'Invalid selection sets data';
        this.selectionSets = [];
        return;
      }
      array.map(item => {
        if (this.selectionSetInFilter(item.name).unmatched === 0) {
          item.allMatched = true;
        } else {
          item.allMatched = false;
        }
        return item;
      })
      this.selectionSets = array;
    },
  }
}
</script>

<style lang="scss" scoped>
.matched-msg {
  background-color: var(--vform-editor-ui-quinary-color);
  display: inline-block;
  width: 400px;
}
.matched-parts {
  border: 1px dashed rgba(255,255,255,0.2);
  background-color: rgba(255,255,255,0.1);
  border-radius: 3px;
  padding: 3px 5px;
}
</style>